import {ReviewDataType} from '../../../service/reviews/reviews-type';
import {getDateInCurrentTimezone} from '../../../util/date';
import {ProvidersIdsEnum} from '../../../util/type';

export function isReviewReplyAllowed(review: ReviewDataType): boolean {
    const {brand, deletedAt, ableToReply} = review;

    return (ableToReply || brand.isTest) && !deletedAt;
}

export function isReviewAbuseAllowed(review: ReviewDataType): boolean {
    const {ableToAbuse, abuseLastDate, catalogId, deletedAt} = review;

    if (!ableToAbuse || deletedAt) {
        return false;
    }

    if (!abuseLastDate) {
        return true;
    }

    return catalogId !== ProvidersIdsEnum.yandex;
}

export function getReviewCreationDate(review: {
    createdInCatalog: ReviewDataType['createdInCatalog'];
    createdInRd: ReviewDataType['createdInRd'];
}): string {
    const {createdInCatalog, createdInRd} = review;

    return getDateInCurrentTimezone(new Date(createdInCatalog || createdInRd))
        .toISOString()
        .replace('Z', '');
}
